<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';

import { frontendUrl } from '@/config';
import languageToSlug from '@/helpers/languageToSlug';
import AddEditForm from '@/components/forums/AddEditForm';
import SingleView from '@/components/elements/views/SingleView';
import ForumManagersTable from '@/components/forums/ForumManagersTable';

export default {
    page: {
        title: 'Manage Forum'
    },

    components: {
        AddEditForm,
        ForumManagersTable
    },

    extends: SingleView,

    validations: {
        item: {
            name: {
                required
            },
            slug: {
                required(value) {
                    const isRequired = this.editMode;

                    return !!(!isRequired || (isRequired && value));
                }
            },
            description: {
                required
            },
            termsLink: {
                required
            },
            termsDescription: {
                required
            }
        },
        language: {
            id: {
                required
            }
        }
    },

    data() {
        const { forumId = null } = this.$route.params;

        return {
            backRoute: '/forums',
            indexName: 'Forums',
            singleItemName: 'forum',
            languagePicker: true,
            meta: true,
            item: {
                language: null,
                id: forumId,
                meta: {},
                articles: [],
                isVisible: true
            }
        };
    },

    computed: {
        additionalStoreData() {
            return { articles: this.item.articles.map(({ id }) => id) };
        },

        itemInformationOptions() {
            return { slugBasicUrl: 'forum' };
        },

        additionalFormComponents() {
            const forumManagersComponent = {
                name: 'forum-managers-table',
                props: {
                    forumId: this.item.id
                }
            };

            const forumManagersCondition = this.editMode && this.item.id;

            const components = forumManagersCondition
                ? [forumManagersComponent]
                : [];

            return components;
        },

        previewUrl() {
            const { slug, language } = this.item;

            const languageSlug = languageToSlug(language);

            const url = frontendUrl.concat(languageSlug);

            return url.concat(`/forum/${slug}`);
        }
    },

    methods: {
        ...mapActions({
            addItem: 'forums/store',
            deleteItem: 'forums/destroy',
            getItem: 'forums/show',
            updateItem: 'forums/update'
        })
    }
};
</script>
